<div class="flex flex-col gap-5 bg-neutral-100 mb-5 py-6">
  <div
    class="flex flex-col px-5 gap-2"
    *ngIf="heading || subheading"
  >
    <h2
      class="font-accent font-bold text-2xl lg:text-3xl text-neutral-800"
      *ngIf="heading"
    >
      {{ heading | translate }}
    </h2>
    <div
      class="text-sm lg:text-base font-base text-neutral-600"
      *ngIf="subheading"
    >
      {{ subheading }}
    </div>
  </div>

  <div
    class="text-sm lg:text-base px-5 font-base text-neutral-600 flex flex-row items-center"
    *ngIf="
      (displayPoints && pointsBalance && pointsBalance > 0) ||
      (displayCredits && creditBalance && creditBalance > 0)
    "
  >
    <i class="icon icon-coins pr-1.5 mt-0.5"></i>
    <span
      *ngIf="displayPoints && pointsBalance && pointsBalance > 0"
      [translate]="'como.amount-of-points'"
      [translateParams]="{ points: pointsBalance / 100 }"
    ></span>
    <span
      *ngIf="
        displayPoints &&
        pointsBalance &&
        pointsBalance > 0 &&
        displayCredits &&
        creditBalance &&
        creditBalance > 0
      "
      class="px-1"
      >—</span
    >
    <span *ngIf="displayCredits && creditBalance && creditBalance > 0">
      {{ 'como.credits-label' | translate }}
      <app-price-atom
        [amount]="creditBalance"
        [format]="true"
        [bold]="false"
        size="SM"
      ></app-price-atom>
    </span>
  </div>

  <div
    class="text-sm lg:text-base px-5 font-base text-neutral-600"
    *ngIf="!assets || assets.length === 0"
  >
    {{ 'como.no-assets' | translate }}
  </div>
  <ul
    class="flex overflow-x-auto pl-5 pr-2 scrollbar-hide"
    *ngIf="assets.length > 0"
  >
    <ng-container *ngIf="displayRedeemableGifts">
      <li
        class="mr-3 min-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of redeemableAssets"
      >
        <app-como-asset-item-atom
          [asset]="asset"
          [displayAddButton]="displayAddButton"
          [isAssetInCart]="isAssetInCart$(asset) | async"
          (assetAdd)="onAssetAdd.emit(asset)"
          (assetRemove)="onAssetRemove.emit(asset)"
        ></app-como-asset-item-atom>
      </li>
    </ng-container>
    <ng-container *ngIf="displayNotRedeemableGifts">
      <li
        class="mr-3 min-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of noRedeemableAssets"
      >
        <app-como-asset-item-atom
          [asset]="asset"
          [displayAddButton]="displayAddButton"
          [isAssetInCart]="isAssetInCart$(asset) | async"
          (assetAdd)="onAssetAdd.emit(asset)"
          (assetRemove)="onAssetRemove.emit(asset)"
        ></app-como-asset-item-atom>
      </li>
    </ng-container>
    <ng-container *ngIf="displayRedeemablePointShop">
      <li
        class="mr-3 min-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of redeemablePointShops"
      >
        <app-como-asset-item-atom
          [asset]="asset"
          [displayAddButton]="displayAddButton"
          [isAssetInCart]="isAssetInCart$(asset) | async"
          (assetAdd)="onAssetAdd.emit(asset)"
          (assetRemove)="onAssetRemove.emit(asset)"
        ></app-como-asset-item-atom>
      </li>
    </ng-container>
    <ng-container *ngIf="displayNotRedeemablePointShop">
      <li
        class="mr-3 min-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of noRedeemablePointShops"
      >
        <app-como-asset-item-atom
          [asset]="asset"
          [displayAddButton]="displayAddButton"
          [isAssetInCart]="isAssetInCart$(asset) | async"
          (assetAdd)="onAssetAdd.emit(asset)"
          (assetRemove)="onAssetRemove.emit(asset)"
        ></app-como-asset-item-atom>
      </li>
    </ng-container>
    <ng-container *ngIf="displayNotUsablePointShop">
      <li
        class="mr-3 min-w-40 w-40 flex-shrink-0 flex-grow-0"
        *ngFor="let asset of pointShops"
      >
        <app-como-asset-item-atom
          [asset]="asset"
          [displayAddButton]="displayAddButton"
          (assetAdd)="onAssetAdd.emit(asset)"
          (assetRemove)="onAssetRemove.emit(asset)"
        ></app-como-asset-item-atom>
      </li>
    </ng-container>
  </ul>
</div>
